<template>
  <div class="border rounded-lg py-2 mt-4" :class="{'border-red-500' : product.errors}">
    <div class="flex items-center">
      <img class="w-16" :src="product.photo.path" alt="">
      <div>
        <h1 class="text-sm">{{ product.name }}</h1>
        <h3 class="text-xs mt-1 text-gray-500">
          قیمت:
          <span class="text-green-500">
          <span>{{ $helper.priceFormatter(product.price, false) }}</span>
        </span>
          تومان
        </h3>
      </div>
      <div class="flex items-center ml-4 mr-auto text-sm">
        <span class="bg-brand px-2 py-0.5 rounded font-bold" @click="incrementCount">+</span>
        <span class="px-2">{{ product.count }}</span>
        <span class="border border-brand px-2 py-0.5 rounded font-bold" @click="decrementCount">-</span>
      </div>
    </div>

    <ul class="text-red-500 text-xs my-2 mx-4 px-4 list-disc" v-if="product.errors">
      <li v-for="error in product.errors" :key="error">{{ error }}</li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "CartProductCard",
  props: ['product'],
  data() {
    return {
      selectedProduct: {}
    }
  },
  created() {
    this.selectedProduct = this.product
  },
  methods: {
    incrementCount() {
      if (this.selectedProduct.count + 1 > this.selectedProduct.inventory) {
        return
      }
      this.selectedProduct.count++
      this.$store.dispatch('addToCart', this.selectedProduct)
    },
    decrementCount() {
      if (this.selectedProduct.count - 1 < 0) {
        return
      } else if (this.selectedProduct.count - 1 === 0) {
        this.$store.dispatch('removeProduct', this.selectedProduct)
        return
      }

      this.selectedProduct.count--
      this.$store.dispatch('addToCart', this.selectedProduct)
    },
  }
}
</script>

<style scoped>

</style>